<div style="border: 1px solid #f8f8f8;padding: 7px;height: 380px;">
    <div class="shimmer mt-2   container photo-placeholder "></div>
    <div class="shimmer mt-1  container name-placeholder"></div>
    <div class="shimmer mt-3  container review-placeholder"></div>
    <div class="shimmer mt-2   container price-placeholder"></div>
    <div class="shimmer mt-3   container button-placeholder"></div>
</div>
